import * as React from 'react';
import cx from 'classnames';
/**
 * @deprecated
 * 建议使用 CnIcon
 */
export class Icon extends React.Component {
    static defaultProps = {
        size: 'medium',
    };
    static _typeMark = 'icon';
    render() {
        const { type, size, className, style, children, rtl, ...others } = this.props;
        const classes = cx(className, {
            'cn-ui-m-icon': true,
            [`cn-ui-m-icon-${type}`]: !!type,
            [`cn-ui-m-icon-${size}`]: !!size && typeof size === 'string',
        });
        if (rtl) {
            // @ts-ignore
            others.dir = 'rtl';
        }
        const sizeStyle = {};
        return (React.createElement("i", { ...others, style: { ...sizeStyle, ...style }, className: classes }, children));
    }
}
